import { render, staticRenderFns } from "./serviceContent.vue?vue&type=template&id=222154d8&scoped=true&"
import script from "./serviceContent.vue?vue&type=script&lang=js&"
export * from "./serviceContent.vue?vue&type=script&lang=js&"
import style0 from "./serviceContent.vue?vue&type=style&index=0&id=222154d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222154d8",
  null
  
)

export default component.exports